import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=94b637b6&scoped=true"
import script from "./DashboardChart.vue?vue&type=script&lang=js"
export * from "./DashboardChart.vue?vue&type=script&lang=js"
import style0 from "./DashboardChart.vue?vue&type=style&index=0&id=94b637b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b637b6",
  null
  
)

export default component.exports